import { render, staticRenderFns } from "./WsReadContentBlock.vue?vue&type=template&id=86642de0&"
import script from "./WsReadContentBlock.vue?vue&type=script&lang=js&"
export * from "./WsReadContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports